import { IbssComponent } from "../Core/BaseComponent/IbssComponent";

export default class EditVisitorStatus extends IbssComponent<IProps, IState>
{
    public render(): JSX.Element
    {
        switch (this.props.value)
        {
            case true:
                return (<span style={{ color: 'var(--ui-success)' }}>{'\u2714'}</span>);
            default: // false
                return (<span style={{ color: 'var(--ui-error)' }}>{'\u2718'}</span>);
        }
    }
}

export interface IProps
{
    value: boolean;
}

export interface IState { }
